var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoFileGraph(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6161 2H7C5.61929 2 4.5 3.11929 4.5 4.5V19.5C4.5 20.8807 5.61929 22 7 22H17C18.3807 22 19.5 20.8807 19.5 19.5V7.88388C19.5 7.55236 19.3683 7.23442 19.1339 7L14.5 2.36612C14.2656 2.1317 13.9476 2 13.6161 2ZM13.875 6.375V3.875L17.625 7.625H15.125C14.4346 7.625 13.875 7.06536 13.875 6.375ZM14.5 18.875V11.375C14.5 11.0298 14.7798 10.75 15.125 10.75H16.375C16.7202 10.75 17 11.0298 17 11.375V18.875C17 19.2202 16.7202 19.5 16.375 19.5H15.125C14.7798 19.5 14.5 19.2202 14.5 18.875ZM11.375 19.5C11.0298 19.5 10.75 19.2202 10.75 18.875V13.875C10.75 13.5298 11.0298 13.25 11.375 13.25H12.625C12.9702 13.25 13.25 13.5298 13.25 13.875V18.875C13.25 19.2202 12.9702 19.5 12.625 19.5H11.375ZM7.625 19.5C7.27982 19.5 7 19.2202 7 18.875V16.375C7 16.0298 7.27982 15.75 7.625 15.75H8.875C9.22018 15.75 9.5 16.0298 9.5 16.375V18.875C9.5 19.2202 9.22018 19.5 8.875 19.5H7.625Z",
    fill: "inherit"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoFileGraph);
export default __webpack_public_path__ + "static/media/ico-file-graph.0976979f0d40acc0cc7d46c0a114429e.svg";
export { ForwardRef as ReactComponent };